import { In } from 'typeorm'

import { Scenario } from '@things-factory/integration-base'

import { DataSet } from '../service/data-set/data-set.js'
import { DataSample } from '../service/data-sample/data-sample.js'
import { DataOoc, DataOocStatus } from '../service/data-ooc/data-ooc.js'

export async function createDataOoc(
  dataSample: DataSample,
  dataSet: DataSet,
  context: ResolverContext
): Promise<DataOoc> {
  const { domain, user, tx } = context.state
  const { collectedAt, data, ooc, oos, judgment, workDate, workShift } = dataSample

  const dataOoc = await tx.getRepository(DataOoc).save({
    ...dataSample,
    history: [
      {
        user: {
          id: user?.id,
          username: user?.username || user?.email,
          name: user?.name
        },
        state: DataOocStatus.ISSUED,
        timestamp: collectedAt
      }
    ],
    state: DataOocStatus.ISSUED,
    dataSample: dataSample
  })

  if (dataSet.outlierScenarioId) {
    var scenarios = await tx.getRepository(Scenario).find({
      where: {
        domain: domain.parentId ? { id: In([domain.id, domain.parentId]) } : { id: domain.id },
        id: dataSet.outlierScenarioId
      },
      relations: ['domain', 'steps', 'updater']
    })

    const scenario = scenarios.find(s => s.domain.id === domain.id) || scenarios.find(s => s.domain.id === domain.parentId)

    if (scenario) {
      scenario.start({
        instanceName: scenario.name + ':' + dataSet.name + ':' + dataSample.id,
        domain,
        user,
        variables: {
          dataOocId: dataOoc.id,
          dataSampleId: dataSample.id,
          dataSet: dataSet.id,
          data,
          ooc,
          oos,
          judgment,
          collectedAt,
          workDate,
          workShift,
          domain: {
            id: domain.id,
            subdomain: domain.subdomain,
            name: domain.name
          },
          updator: {
            id: user.id,
            username: user.username || user.email,
            email: user.email,
            name: user.name
          }
        }
      })
    } else {
      console.error(`Cannot find the set outlier-scenario for the dataset(${dataSet.name}).`)
    }
  }

  return dataOoc
}
